import { render, staticRenderFns } from "./LeaveMessage.vue?vue&type=template&id=cbad16b6&scoped=true"
import script from "./LeaveMessage.vue?vue&type=script&lang=js"
export * from "./LeaveMessage.vue?vue&type=script&lang=js"
import style0 from "./LeaveMessage.vue?vue&type=style&index=0&id=cbad16b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbad16b6",
  null
  
)

export default component.exports